import React from "react";
import { Link } from "react-router-dom";
import {
  FaUser,
  FaBuilding,
  FaRocket,
  FaEnvelope,
  FaPhoneAlt,
  FaWhatsapp,
  FaArrowRight,
  FaCheckCircle,
  FaClock,
  FaBell,
  FaHeadset,
} from "react-icons/fa";
import "./SubscriptionSection.css";

const SubscriptionSection = () => {
  return (
    <section className="staffline-subscription-section">
      <div className="container">

        {/* ===== HEADER ===== */}
        <div className="staffline-subscription-header">
          <span className="staffline-subscription-tag">
            <FaRocket /> Portal in Development
          </span>
          <h2 className="staffline-subscription-title">
            Our Subscription Portal Is Coming Soon
          </h2>
          <p className="staffline-subscription-desc">
            We're building a powerful, self-service portal that will be open to
            both <strong>individual subscribers</strong> and{" "}
            <strong>corporate companies</strong>. Until then, you can subscribe
            by contacting us directly.
          </p>
        </div>

        {/* ===== TWO AUDIENCE CARDS ===== */}
        <div className="staffline-subscription-audience">
          {/* Individual Card */}
          <div className="staffline-subscription-audience-card">
            <div className="staffline-subscription-audience-icon">
              <FaUser />
            </div>
            <h3>For Individuals</h3>
            <p>
              Are you a worker looking for a reliable daily commute? Subscribe
              now and secure your seat on your preferred route.
            </p>
            <ul className="staffline-subscription-audience-list">
              <li>
                <FaCheckCircle /> Flat fee: 800 GHS / month
              </li>
              <li>
                <FaCheckCircle /> Assigned seat & bus
              </li>
              <li>
                <FaCheckCircle /> 24+ routes available
              </li>
              <li>
                <FaCheckCircle /> Mon – Fri service
              </li>
            </ul>
            <Link
              to="/contact-us"
              className="staffline-subscription-audience-btn"
            >
              Contact Us to Subscribe <FaArrowRight />
            </Link>
          </div>

          {/* Corporate Card */}
          <div className="staffline-subscription-audience-card staffline-subscription-audience-card-accent">
            <div className="staffline-subscription-audience-icon">
              <FaBuilding />
            </div>
            <h3>For Corporate Companies</h3>
            <p>
              Offer your staff a white-label shuttle service. Reduce lateness,
              boost morale, and retain top talent with a company-subsidized
              plan.
            </p>
            <ul className="staffline-subscription-audience-list">
              <li>
                <FaCheckCircle /> Bulk subscriptions (20+ employees)
              </li>
              <li>
                <FaCheckCircle /> Company subsidy up to 50%
              </li>
              <li>
                <FaCheckCircle /> Custom routes on request
              </li>
              <li>
                <FaCheckCircle /> Monthly invoicing & reports
              </li>
            </ul>
            <Link
              to="/contact-us"
              className="staffline-subscription-audience-btn staffline-subscription-audience-btn-accent"
            >
              Request Corporate Quote <FaArrowRight />
            </Link>
          </div>
        </div>

        {/* ===== COMING SOON BANNER ===== */}
        <div className="staffline-subscription-coming-soon">
          <div className="staffline-subscription-coming-soon-left">
            <div className="staffline-subscription-coming-soon-icon">
              <FaBell />
            </div>
            <div>
              <h3>Want to be first in line?</h3>
              <p>
                Contact us now to reserve your spot. We'll notify you the moment
                our portal goes live.
              </p>
            </div>
          </div>

          <div className="staffline-subscription-coming-soon-right">
            <a
              href="https://wa.me/233531030191"
              target="_blank"
              rel="noopener noreferrer"
              className="staffline-subscription-coming-soon-btn staffline-subscription-coming-soon-btn-whatsapp"
            >
              <FaWhatsapp /> Chat on WhatsApp
            </a>
            <a
              href="tel:+233531030191"
              className="staffline-subscription-coming-soon-btn"
            >
              <FaPhoneAlt /> Call Us
            </a>
          </div>
        </div>

        {/* ===== HOW TO SUBSCRIBE NOW ===== */}
        <div className="staffline-subscription-steps">
          <div className="staffline-subscription-steps-header">
            <h3>How to Subscribe Today</h3>
            <p>
              Three simple ways to reach us — pick whichever suits you best.
            </p>
          </div>

          <div className="staffline-subscription-steps-grid">
            {/* Step 1 - WhatsApp */}
            <a
              href="https://wa.me/233531030191"
              target="_blank"
              rel="noopener noreferrer"
              className="staffline-subscription-step"
            >
              <div className="staffline-subscription-step-icon">
                <FaWhatsapp />
              </div>
              <h4>Chat on WhatsApp</h4>
              <p>
                Send us a message with your route and personal details. We'll
                respond within minutes.
              </p>
              <span className="staffline-subscription-step-cta">
                Chat Now <FaArrowRight />
              </span>
            </a>

            {/* Step 2 - Email */}
            <a
              href="mailto:info@stafflinetransport.com"
              className="staffline-subscription-step"
            >
              <div className="staffline-subscription-step-icon">
                <FaEnvelope />
              </div>
              <h4>Email Us</h4>
              <p>
                Send your details to{" "}
                <strong>stafflinetransportgh@gmail.com</strong> and we'll get back
                within 24 hours.
              </p>
              <span className="staffline-subscription-step-cta">
                Send Email <FaArrowRight />
              </span>
            </a>

            {/* Step 3 - Contact Form */}
            <Link to="/contact-us" className="staffline-subscription-step">
              <div className="staffline-subscription-step-icon">
                <FaHeadset />
              </div>
              <h4>Fill the Contact Form</h4>
              <p>
                Use our contact page to tell us your preferred route and
                pickup point. We'll do the rest.
              </p>
              <span className="staffline-subscription-step-cta">
                Go to Contact <FaArrowRight />
              </span>
            </Link>
          </div>
        </div>

        {/* ===== FEATURES PREVIEW ===== */}
        <div className="staffline-subscription-features">
          <div className="staffline-subscription-features-header">
            <h3>What's Coming in the Portal</h3>
            <p>
              A modern, self-service experience designed for both individuals
              and companies.
            </p>
          </div>

          <div className="staffline-subscription-features-grid">
            <div className="staffline-subscription-feature">
              <FaUser />
              <h4>Individual Dashboard</h4>
              <p>Manage your seat, route, and payments in one place.</p>
            </div>
            <div className="staffline-subscription-feature">
              <FaBuilding />
              <h4>Corporate Dashboard</h4>
              <p>Add employees, track usage, and manage invoices easily.</p>
            </div>
            <div className="staffline-subscription-feature">
              <FaClock />
              <h4>Digital ID Card</h4>
              <p>Download or print your StaffLine ID card anytime.</p>
            </div>
            <div className="staffline-subscription-feature">
              <FaBell />
              <h4>Smart Notifications</h4>
              <p>SMS and email alerts for schedule changes and renewals.</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SubscriptionSection;